import dashboardServices from '../services/hoa-dashboard-api-service';
import datastore from '../store/hoa-datastore';
import { GlobalContext } from '../context/hoa-global-context';
import { useContext } from 'react';

export default function MunicipalityController(){

    const { muncipality } = useContext<any>(GlobalContext)

    const getMunicipalities = async (numberOfMuncipality:number,pageNo:number) => {
        const { data } = await dashboardServices.getMunicipalities(numberOfMuncipality,pageNo,muncipality.options);
        return {
            data: data.municipalities,
            count: data.parseCount
        };
    }

    return{
        getMunicipalities
    }

}